import { capitalize } from "../../../helpers/string/capitalize";
import { TitleWithStyles } from "../../../ui/layout";

export const unfulfilledConditionPage = (
  condition: string,
  pageName: string,
  action = "add",
) => (
  <>
    <TitleWithStyles title={capitalize(pageName)} />
    <p className="text-primary mt-8">{`Please ${condition} in order to ${action} ${pageName}.`}</p>
  </>
);
